import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Seat from './Seat';
import { LegendContainer, LegendItem, LegendLabel } from './SeatMapLegend.styles';

const SeatMapLegend = ({ isERTrain = false }) => (
  <LegendContainer data-testid="seat-map-legend" data-cy="seat-map-legend">
    <LegendItem>
      <Seat isErSeat={isERTrain} /> - <FormattedMessage id="seatMapLegend.available" />
    </LegendItem>
    <LegendItem>
      <Seat isErSeat={isERTrain} dataStatus="unavailable" /> - <FormattedMessage id="seatMapLegend.unavailable" />
    </LegendItem>
    <LegendItem>
      <Seat isErSeat={isERTrain} dataStatus="assigned" /> - <FormattedMessage id="seatMapLegend.yourSeat" />
    </LegendItem>
    <LegendItem>
      <Seat isErSeat={isERTrain} dataStatus="non-editable" /> - <FormattedMessage id="seatMapLegend.yourNonEditableSeat" />
    </LegendItem>
    <LegendItem>
      <Seat isErSeat={isERTrain} dataStatus="blocked" /> - <FormattedMessage id="seatMapLegend.yourReleasedSeat" />
    </LegendItem>
    <LegendItem>
      <LegendLabel>P</LegendLabel> - <FormattedMessage id="seatMapLegend.prioritySeat" />
    </LegendItem>
  </LegendContainer>
);

SeatMapLegend.propTypes = {
  isERTrain: PropTypes.bool
};

export default SeatMapLegend;
